export default __webpack_public_path__ + "static/media/landscape34.bfbbb5eb.jpeg";